import AppModal from "../appModal/AppModal";

/**
 * @param {React Component} children Anything that could be used in between opening and closing tags
 * @param {boolean} open
 *          => if true it displays the modal
 *          => if false the modal won't be displayed
 * @param {function} setOpen the setOpen which will be used to close the modal
 * @param {function} confirmFunction 
 *          => The function that will run if user clicks Confirm | Accept
 *          => If not passed in will be set to default handleClose
 * @param {function} cancelFunction 
 *          => The function that will run if user clicks confirm
 *          => If not passed in will be set to default handleClose
 *
 * @returns {React Component} Error App Modal
 */

/**
 * Sample Code
 * 
 *  const [open, setOpen] = useState(false);
 * 
 *  <SaveModal open={open} setOpen={setOpen} confirmFunction={()=> alert('Accepted')} cancelFunction={()=> alert('Canceled')}>
 *      Hello this is an Error Message
 *  </SaveModal>
 *  
 *  <button onClick={() => setOpen(true)}>
 *      SAVE CHNAGES?
 *  </button>                       
 */

const SaveModal = ({ children, open, setOpen, confirmFunction, cancelFunction }) => {
    const handleClose =  () => setOpen(false);
    
    return (
        <AppModal
            config={{
                type: "save",
                open,
                handleClose,
                buttons: {
                    actionButton: {
                        text: "Accept",
                        actionFunction: confirmFunction || handleClose,
                        secondaryButton: false
                    },
                    cancel:{
                        text: "Cancel",
                        actionFunction: cancelFunction || handleClose,
                        secondaryButton: true
                    }
                },
            }}
        >
            {children}
        </AppModal>
    );
};

export default SaveModal;
